// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { CommonModule, } from '@angular/common';

// Local library
import { FundingFacade } from '@amwager/funding/data-access';
import { CommonFacade, SessionService } from '@amwager/data-access';

import { AccountFacade } from '@amwager/account/data-access';
import {
  UnsubscribeObservableService
} from '@amwager/util';

// Third party
import { Subscription, takeUntil } from 'rxjs';
import { forEach } from 'lodash';

// Ionic
import { AlertController, IonCheckbox, IonIcon } from '@ionic/angular/standalone';


@Component({
  selector: 'feature-ion-check-by-email',
  templateUrl: './check-by-email.component.html',
  styleUrls: ['./check-by-email.component.scss'],
  imports: [
    CommonModule,
    IonIcon,
    IonCheckbox,
    ReactiveFormsModule,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckByEmailComponent extends UnsubscribeObservableService implements OnInit {

  checkByEmailForm!: FormGroup;
  // convenience getter for easy access to form fields
  get formVal() { return this.checkByEmailForm?.controls }
  private subsWithdrawCheckByEmailResponse!: Subscription;

  showErrorMsg = '';
  amount!: number;
  total!: number;
  isProcessing = false;
  isAgree = false;

  fullName!: string;
  address!: string;
  location!: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly sessionService: SessionService,
    private readonly fundingFacade: FundingFacade,
    private readonly accountFacade: AccountFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly commonFacade: CommonFacade,
    private readonly alertCtrl: AlertController,
  ) {
    super();
  }

  ngOnInit() {

    this.initForm();
    // this.formVal['amount']?.setValue(25);
    // this.amount = 25;
    // this.fee = 0;
    this.total = this.amount;

    this.fullName = 'Loading...';
    this.address = 'Loading...';
    this.location = 'Loading...';

    this.accountFacade.getUserAccoutAPI();
    this.accountFacade.isGetUserAccountSuccess$()
    .pipe(takeUntil(this.toUnsubscribe$))
    .subscribe((response) => {
      // console.log(response);
      if (response !== undefined) {
        this.fullName = this.sessionService.getUserFName() + ' ' + this.sessionService.getUserLast();
        this.address = response.Address;
        this.location = response.TownCity + ', ' + response.State + ' ' + response.Zipcode;
      }

      this.cdRef.markForCheck();
    });

  }

  private initForm(): void {
    this.checkByEmailForm = this.formBuilder.group({
      amount: ['', [Validators.required]]
    });
  }

  async showAlertMessage(header: string, message: string): Promise<void> {
    const alert = await this.alertCtrl.create({
      header,
      message: message,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
          }
        }
      ]
    });

    await alert.present();
  }

  withdrawAmount(): void {
    this.amount = this.formVal['amount']?.value;
    this.total = this.amount;
  }

  withdraw(): void {
    if (!navigator.onLine) {
      this.commonFacade.setIsConnectedInternet('CheckByEmailComponent:withdraw', false);
      return;
    }

    if (this.checkByEmailForm.valid && this.amount && this.isAgree) {
      this.isProcessing = true;

      this.fundingFacade.withdrawCheckByEmail(
        'Check',
        this.amount
      );
      this.subsWithdrawCheckByEmailResponse = this.fundingFacade.isWithdrawCheckByEmailSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe(({response, isSuccess}) => {
        if (!isSuccess && response !== undefined) {
          this.showAlertMessage('Withdraw Error', response.error.Message);
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }


        this.subsWithdrawCheckByEmailResponse?.unsubscribe();

        if (isSuccess) {
          this.showAlertMessage('Successful Withdrawal', 'Check Withdrawal successful. Your request will be processed within 2 business days.');
          this.checkByEmailForm.reset();
          this.isAgree = false;
          this.isProcessing = false;
          this.cdRef.markForCheck();
        }
      });
    }
    else {
      this.markFormGroupTouched(this.checkByEmailForm);
    }
  }

  toggleCheckbox(): void {
    this.isAgree = !this.isAgree;
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    forEach(formGroup.controls, (control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

}
